import { CustomAxios } from "@shared/api/axiosClient";

// Reservas del colaborador autenticado
export const getReservations = () =>
  CustomAxios.get("reservations").then(({ data }) => data.data ?? []);

// Casas vacacionales para el selector de ubicación.
export const getVacationHomes = () =>
  CustomAxios.get("vacation-homes").then(({ data }) => data);

// Cancela una reserva. El backend computa el contexto (umbral ≤5 días) por su cuenta;
// el front solo manda el id.
export const cancelReservation = ({ reservationId }) =>
  CustomAxios.put(`reservations/${reservationId}/cancel`).then(({ data }) => data);

// Guarda los invitados de una reserva.
export const saveReservationGuests = ({ reservationId, guests }) =>
  CustomAxios.put(`reservations/${reservationId}/guests`, guests);

// Crea/actualiza una reserva desde el wizard con el payload limpio (ReservationInputDTO).
export const createReservation = (reservation) =>
  CustomAxios.post("reservations", reservation);

export const updateReservation = (reservation) =>
  CustomAxios.put("reservations", reservation);

// Consulta disponibilidad de habitaciones. endpoint = "availability" |
// "availability-by-user"; params se serializa como query string.
export const getRoomAvailability = (endpoint, params) =>
  CustomAxios.get(`reservations/${endpoint}?${new URLSearchParams(params)}`);
